const pageNameKey = "emptyTicketContainerTicketsPage";

export const emptyTicketContainerTicketsPageEn = {
  [pageNameKey]: {
    noTicketSelectedTitle: "No ticket selected",
    noTicketSelectedMessage: "No ticket details available.",
  },
};

export const emptyTicketContainerTicketsPagePtBr = {
  [pageNameKey]: {
    noTicketSelectedTitle: "Nenhum ticket selecionado",
    noTicketSelectedMessage: "Nenhum detalhe do ticket disponível.",
  },
};

export const emptyTicketContainerTicketsPageDe = {
  [pageNameKey]: {
    noTicketSelectedTitle: "Kein Ticket ausgewählt",
    noTicketSelectedMessage: "Keine Ticketdetails verfügbar.",
  },
};

export const emptyTicketContainerTicketsPageZhHans = {
  [pageNameKey]: {
    noTicketSelectedTitle: "未选择票据",
    noTicketSelectedMessage: "没有可用的票据详情。",
  },
};

export const emptyTicketContainerTicketsPageIt = {
  [pageNameKey]: {
    noTicketSelectedTitle: "Nessun ticket selezionato",
    noTicketSelectedMessage: "Nessun dettaglio del ticket disponibile.",
  },
};

export const emptyTicketContainerTicketsPageEs = {
  [pageNameKey]: {
    noTicketSelectedTitle: "No se ha seleccionado ningún ticket",
    noTicketSelectedMessage: "No hay detalles del ticket disponibles.",
  },
};

export const emptyTicketContainerTicketsPageNl = {
  [pageNameKey]: {
    noTicketSelectedMessage: "Geen ticketgegevens beschikbaar.",
    noTicketSelectedTitle: "Geen ticket geselecteerd",
  },
};

export const emptyTicketContainerTicketsPageTr = {
  [pageNameKey]: {
    noTicketSelectedMessage: "Bilet detayları mevcut değil.",
    noTicketSelectedTitle: "Bilet seçilmedi",
  },
};
